import {
  Alert,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import StyledButton from "../dashboard/StyledButton";
import { TransactionsTableRowStylesStyles } from "./styles/TransactionsTableRowStyles.styles";

interface NoteDialogProps {
  open: boolean;
  addNewNote: string;
  showNotification: boolean;
  setAddNewNote: React.Dispatch<React.SetStateAction<string>>;
  onClose: () => void;
  onConfirm: () => void;
}

const NoteDialog = (props: NoteDialogProps) => {
  const { open, addNewNote, showNotification, setAddNewNote, onClose, onConfirm } = props;
  const classes = TransactionsTableRowStylesStyles();
  // test
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent className={classes.dialogContent}>
        <Grid container className={classes.container} style={{ height: "50%" }}>
          <Grid container>
            <Grid item xs={12}>
              <Typography className={classes.description}>Notes</Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                placeholder="Enter your note here, e.g. trade for the day"
                fullWidth={true}
                multiline
                defaultValue={addNewNote}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setAddNewNote(event.target.value);
                }}
                rows={4}
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.button}>
        {showNotification ? (
          <Box style={{ paddingTop: "10px", width: "100%" }}>
            <Alert variant="filled" severity="success">
              Note saved successfully!
            </Alert>
          </Box>
        ) : (
          <StyledButton onClick={onConfirm}>Add Notes</StyledButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default NoteDialog;
